import React from 'react';

export const Card = ({ className, children }: { className?: string, children: React.ReactNode }) => {
  return (
    <div className={`bg-white shadow rounded-lg overflow-hidden ${className || ''}`}>
      {children}
    </div>
  );
};

export const CardHeader = ({ className, children }: { className?: string, children: React.ReactNode }) => {
  return (
    <div className={`p-6 pb-0 ${className || ''}`}>
      {children}
    </div>
  );
};

export const CardTitle = ({ className, children }: { className?: string, children: React.ReactNode }) => {
  return (
    <h2 className={`font-bold text-xl ${className || ''}`}>
      {children}
    </h2>
  );
};

export const CardContent = ({ className, children }: { className?: string, children: React.ReactNode }) => {
  return (
    <div className={`p-6 ${className || ''}`}>
      {children}
    </div>
  );
};